import { IFRResource } from "app/resources/ifrresource";
import { UserResource } from "app/resources/user/user-resource";
import { CMSResource } from '../cmsresource';
import { SliderPhotoListResource } from './SliderPhotoListResource';
import { SliderVideoListResource } from './SliderVideoListResource';
import { SliderFilesAndKioskResource } from 'app/models/SliderFilesAndKioskResource';

export class SliderFilesResource extends CMSResource {

	rid: number;
	userEmail: string;
	video: boolean;
	photo: boolean;
	photos: SliderPhotoListResource;
	videos: SliderVideoListResource;

	kioskResourceList: SliderFilesAndKioskResource[];

	showDelete: boolean = false;
}
